import * as React from "react";
import TextField from "@mui/material/TextField";
import { FieldRenderProps } from "react-final-form";
import { WithStyles } from "@mui/styles";
import createStyles from "@mui/styles/createStyles";
import withStyles from "@mui/styles/withStyles";
import * as classnames from "classnames";
import { InputProps } from "@mui/material";

interface ITextFielControl {
  label?: string;
  multiline?: boolean;
  rows?: string;
  rowsMax?: string;
  min?: number;
  max?: number;
  // tslint:disable-next-line: no-any
  variant?: any;
  // tslint:disable-next-line: no-any
  onchange?: (e: any) => any;
  readonly?: boolean;
  resizeY?: boolean;
  autoComplete?: string;
  step?: number;
  inputProps?: InputProps;
}

class TextFieldControl extends React.Component<
  FieldRenderProps & ITextFielControl & WithStyles<"root" | "input" | "resizeY">
> {
  public render(): JSX.Element {
    const {
      classes,
      label,
      multiline,
      rowsMax,
      rows,
      input: { name, onChange, value, ...restInput },
      meta,
      min,
      max,
      step,
      variant,
      onchange,
      readonly,
      resizeY,
      autoComplete,
      inputProps,
      ...rest
    } = this.props;
    // `InputLabelProps` required since `restInput` override `onFocus` action
    const root = classnames.default(classes.root, resizeY ? classes.resizeY : "");

    return (
      <TextField
        {...rest}
        classes={{
          root,
        }}
        fullWidth={true}
        label={label}
        value={value}
        name={name}
        helperText={meta.touched ? meta.error || meta.submitError : undefined}
        error={(meta.error || meta.submitError) && meta.touched}
        InputProps={{
          autoComplete: autoComplete,
          readOnly: readonly,
          inputProps: min || step || max ? { min, step, max } : {},
          classes: label
            ? {}
            : {
                multiline: classes.input,
                inputMultiline: classes.input,
                inputSizeSmall: multiline ? undefined : classes.input,
              },
          startAdornment: (rest as any)?.InputProps?.startAdornment || null,
          endAdornment: (rest as any)?.InputProps?.endAdornment || null,
          ...(inputProps || {}),
        }}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={
          {
            ...restInput,
            "data-cy": name,
          } as any
        }
        // tslint:disable-next-line: no-any
        onChange={(e: any) => {
          onChange(e);
          if (onchange) {
            onchange(e);
          }
        }}
        multiline={multiline}
        rows={rows}
        maxRows={rowsMax}
        margin={multiline ? "normal" : "dense"}
        variant={variant ? variant : "filled"}
      />
    );
  }
}

const styles = createStyles({
  root: {
    width: "100%",
    marginTop: 0,
    marginBottom: 0,
    "&.MuiFilledInput-root": {
      backgroundColor: "rgba(0, 0, 0, 0.09)",
    },
    "&.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
    "& .MuiInputBase-input": {
      paddingTop: "8px",
    },
  },
  input: {
    padding: 6,
  },
  resizeY: {
    "& textarea": {
      resize: "vertical",
    },
  },
});

export default withStyles(styles)(TextFieldControl);
